import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=ae4e648c&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae4e648c')) {
      api.createRecord('ae4e648c', component.options)
    } else {
      api.reload('ae4e648c', component.options)
    }
    module.hot.accept("./LangSelect.vue?vue&type=template&id=ae4e648c&", function () {
      api.rerender('ae4e648c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LangSelect.vue"
export default component.exports